export class InvalidRelationCompany extends Error {
  constructor (message: string) {
    super(message)
    this.name = 'InvalidRelationCompany'
  }
}
